import { render } from "./ConfigCompany.vue?vue&type=template&id=55731476&scoped=true"
import script from "./ConfigCompany.vue?vue&type=script&lang=js"
export * from "./ConfigCompany.vue?vue&type=script&lang=js"

import "./ConfigCompany.vue?vue&type=style&index=0&id=55731476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55731476"]])

export default __exports__